import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
/**
1 * main.ts -> app.config.ts -> app.component.ts -> 라우터 따라
 *
 *
 */
